export default __webpack_public_path__ + "static/media/sh_1.ff7025e6.png";